import { useState } from "react";
import { fieldLabelStyle, inactiveToggleStyle, inputStyle, notInvoicedStyle } from "../styles/materielStyles";

// Identité d'un patient commune au suivi et aux contacts : nom, prénom, « pas facturé » et patient inactif.

export function NotInvoicedToggle({ checked, onChange }) {
    return (
        <label aria-label="Pas facturé" style={notInvoicedStyle(checked)}>
            <input type="checkbox" checked={checked} onChange={event => onChange(event.target.checked)} />
            <span>
                <strong style={{ display: "block" }}>Pas facturé</strong>
                <small style={{ color: "#6b7280" }}>La ligne apparaîtra sur fond rouge</small>
            </span>
        </label>
    );
}

export function InactiveToggle({ inactive, onToggle }) {
    return (
        <button type="button" aria-pressed={inactive} onClick={onToggle} style={inactiveToggleStyle(inactive)}>
            {inactive ? "Passer ce patient en actif" : "Passer ce patient en inactif"}
        </button>
    );
}

// Formulaire d'identité : le nom et le prénom sont obligatoires ; onSave reçoit les valeurs nettoyées et le libellé
// « NOM Prénom ».
export function usePatientIdentityForm(initial, onSave) {
    const [form, setForm] = useState({
        nom: initial.nom || "",
        prenom: initial.prenom || "",
        notInvoiced: Boolean(initial.notInvoiced),
        inactive: Boolean(initial.inactive),
    });
    const [error, setError] = useState("");

    const submit = async event => {
        event.preventDefault();
        if (!form.nom.trim() || !form.prenom.trim()) {
            setError("Le nom et le prénom sont obligatoires.");
            return;
        }
        setError("");
        await onSave({
            nom: form.nom.trim(),
            prenom: form.prenom.trim(),
            patient: `${form.nom.trim()} ${form.prenom.trim()}`,
            notInvoiced: form.notInvoiced,
            inactive: form.inactive,
        });
    };

    const setField = (field, value) => setForm(current => ({ ...current, [field]: value }));
    return { form, setField, error, submit };
}

export function PatientNameFields({ form, setField }) {
    return (
        <>
            <label style={fieldLabelStyle}>
                Nom
                <input value={form.nom} onChange={event => setField("nom", event.target.value)} style={inputStyle} autoFocus />
            </label>
            <label style={fieldLabelStyle}>
                Prénom
                <input value={form.prenom} onChange={event => setField("prenom", event.target.value)} style={inputStyle} />
            </label>
        </>
    );
}

export function PatientStatusFields({ form, setField }) {
    return (
        <>
            <NotInvoicedToggle checked={form.notInvoiced} onChange={checked => setField("notInvoiced", checked)} />
            <InactiveToggle inactive={form.inactive} onToggle={() => setField("inactive", !form.inactive)} />
        </>
    );
}
